import { colors, FONT, radii } from '../../../theme';

/**
 * Tokens for the settings screens.
 *
 * Separate from `S` in dashboardStyles because `S.settingsRow` is used outside
 * settings and changing it would move things nobody asked to move.
 *
 * One token here is not cosmetic. `colors.gray400` on the page background is
 * 3.63:1 — below the 4.5 that small text needs, and the app ships
 * `maximum-scale=1, user-scalable=no`, so a person cannot zoom their way out
 * of it. Every line that explains a consequence uses `consequence`: 13px in
 * gray600, which measures 6.5:1. Explanations nobody can read on the move are
 * the same as no explanations.
 */
export const SS = {
  // A whole row is one button. Nested buttons inside a row are forbidden, not
  // discouraged: the delete control that lived inside a list row was an 18px
  // target next to the least reversible action in the app.
  navRow: {
    display: 'flex', alignItems: 'center', gap: 12, width: '100%',
    minHeight: 56, padding: '10px 16px', textAlign: 'left',
    background: 'transparent', border: 'none', cursor: 'pointer',
    fontFamily: FONT, color: colors.gray900,
  },
  navRowTitle: { fontSize: 15, fontWeight: 500, color: colors.gray900 },
  navRowValue: { fontSize: 15, color: colors.gray600, marginLeft: 'auto' },
  navRowBadge: {
    marginLeft: 'auto', minWidth: 22, height: 22, borderRadius: 11,
    background: colors.amber, color: colors.gray900,
    fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center',
    justifyContent: 'center', padding: '0 7px',
  },
  screen: { paddingBottom: 'calc(80px + env(safe-area-inset-bottom))' },
  screenHeader: {
    display: 'flex', alignItems: 'center', gap: 4,
    padding: '4px 8px 12px', fontFamily: FONT,
  },
  // 44×44 is the smallest target a thumb hits reliably; the back arrow is the
  // one control every screen has.
  backBtn: {
    width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'none', border: 'none', cursor: 'pointer', color: colors.gray900,
  },
  screenTitle: { fontSize: 20, fontWeight: 600, color: colors.gray900, fontFamily: FONT },
  consequence: { fontSize: 13, color: colors.gray600, lineHeight: 1.4, fontFamily: FONT },
  hint: {
    display: 'flex', gap: 10, alignItems: 'flex-start',
    background: 'rgba(220,120,40,0.12)', borderRadius: radii.sm,
    padding: '12px 14px', marginBottom: 16, fontFamily: FONT,
    fontSize: 13, color: colors.gray900, lineHeight: 1.45, cursor: 'pointer',
    border: 'none', width: '100%', textAlign: 'left',
  },
  // Destructive things live below a line and are text, not buttons: harder to
  // hit by accident than the safe option above them.
  dangerZone: { marginTop: 32, paddingTop: 16, borderTop: `1px solid ${colors.gray200}` },
  dangerLink: {
    background: 'none', border: 'none', color: colors.red, fontFamily: FONT,
    fontSize: 15, cursor: 'pointer', padding: '12px 16px', minHeight: 44, width: '100%',
    textAlign: 'left',
  },
};
